export enum LabServiceType {
  RADIOLOGY = 'RADIOLOGY',

  PATHALOGY = 'PATHALOGY',

  BOTH = 'BOTH',
}
